import styled from "styled-components"

import { Button } from "components/common/index"

const VibeButton = styled(Button).attrs((props) => ({
  as: props.as,
  href: props.href,
}))`
  ${(props) => `
    background-color: ${props.theme.colors.black};
    border-radius: 5px;
    color: ${props.theme.colors.white};
    font-size: ${props.theme.fontSizes[14]};
    font-weight: bold;
    height: ${props.theme.space[4]};
    letter-spacing: 0.5px;
    padding: 5px 0;
    text-align: center;
    width: 48%;
  `}
`

export default VibeButton
